import { render, staticRenderFns } from "./defaultModal.vue?vue&type=template&id=64953b08&scoped=true&"
import script from "./defaultModal.vue?vue&type=script&lang=js&"
export * from "./defaultModal.vue?vue&type=script&lang=js&"
import style0 from "./defaultModal.vue?vue&type=style&index=0&id=64953b08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64953b08",
  null
  
)

component.options.__file = "defaultModal.vue"
export default component.exports